// extracted by mini-css-extract-plugin
export var emailInputBubbleContainer = "_nu-0";